module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-teacher"
  }, [_c('h3', {
    staticClass: "title",
    style: ({
      color: _vm.color
    })
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jiabin",
    staticStyle: {
      "margin-right": "10px"
    }
  }), _vm._v("\n      " + _vm._s(_vm.data.cpnTitle) + " " + _vm._s(_vm.data.cpnData.length) + " " + _vm._s(_vm.language == 'ch' ? '位' : '') + "\n      ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "12px",
      "color": "red",
      "font-size": "12px",
      "margin-top": "4px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.data.cpnContent))])]), _vm._v(" "), _vm._l((_vm.data.cpnData), function(item, i) {
    return (_vm.data.cpnData.length > 0) ? _c('div', {
      key: i,
      staticClass: "list"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.uIcon ? item.uIcon : 'http://medcircle.cn/lib/img/tpl-default-avatar.jpg'),
        expression: "item.uIcon ? item.uIcon : 'http://medcircle.cn/lib/img/tpl-default-avatar.jpg'"
      }],
      staticClass: "avatar",
      attrs: {
        "alt": ""
      }
    }), _vm._v(" "), _c('ul', {
      staticClass: "text-con"
    }, [_c('li', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.uName))]), _vm._v(" "), (item.uTitle) ? _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.title")) + "：")]), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.uTitle))])]) : _vm._e(), _vm._v(" "), (item.uOrg) ? _c('li', [_c('span', [_vm._v(_vm._s(_vm.$t("message.tpl3.menu.org")) + ": ")]), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.uOrg))])]) : _vm._e()]), _vm._v(" "), (item.uDesc) ? _c('div', {
      staticClass: "con",
      domProps: {
        "innerHTML": _vm._s(item.uDesc)
      }
    }) : _vm._e()]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7da0d18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/teacher.vue
// module id = 825
// module chunks = 10